import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PROMOTE_FORM_LAYOUT_EXPERIMENT = createFcmDetails('promote_form_layout_experiment', {
	owner: 'Monetization Squad',
	context: 'New Payment form layout on Promote Page',
	description:
		'This feature config enables the experiment for specific locales or countries. The experiment requires dynamic treatment and uses the "promoted_checkout_form_v1" experiment configuration.',
	template: {
		enabled: false,
	},
	import: false,
});
